<template>
    <!-- 排行榜 -->
    <div class="order"
         :style="{'border-bottom-color': index<4?'#5BAED3':'#B9DDED'}">
        <span class="d-block">{{ indexNumber }}</span>
    </div>
</template>
<script>
export default {
    name: 'InOrder',
    props: {
        index: {
            type: Number,
            require: true,
        },
    },
    computed: {
        indexNumber() {
            return this.index.toString().padStart(2, '0');
        },
    },
};
</script>
<style lang="scss" scoped>
.order {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 60px 60px 0 0;
    // border-color: transparent transparent $primary transparent;
    border-top-color: $primary;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: transparent;
    position: absolute;
    top: 0;
    left: 0;
    @include media-breakpoint-up(sm) {
        border-width:  90px 90px 0  0;
    }
    @include media-breakpoint-up(md) {
        border-width:  70px 70px 0 0 ;
    }
    @include media-breakpoint-up(lg) {
        border-width:  90px 90px 0  0;
    }
    span {
        line-height: 1.2;
        color: white;
        position: absolute;
        top: -3.5rem;
        left: 0.35rem;
        font-size: 1.25rem;
        @include media-breakpoint-up(sm) {
            font-size: 1.875rem;
            left: 0.5rem;
            top: -5rem;
        }
        @include media-breakpoint-up(md) {
            font-size: 1.5rem;
            left: 0.35rem;
            top: -4rem;
        }
        @include media-breakpoint-up(lg) {
            font-size: 1.875rem;
            left: 0.5rem;
            top: -5rem;
        }
    }
}
</style>
